<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
                <b-row>
                    <b-col xl="11" lg="11" sm="12">
                        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                            <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset">
                                <b-row>
                                 <b-col lg="4" sm="12">
                                   <ValidationProvider name="Promotion Type (En)" vid="promotion_type" rules="required|min_value:1">
                                      <b-form-group
                                       class="row"
                                       label-cols-sm="12"
                                       label-for="promotion_type_id"
                                       >
                                       <template v-slot:label>
                                         {{$t('promotionManagement.promotion_type')}} <span class="text-danger">*</span>
                                       </template>
                                       <b-form-select
                                        plain
                                        v-model="user.promotion_type_id"
                                        id="promotion_type_id"
                                        :options="promotionTypesList"
                                        >
                                        <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        </b-form-group>
                                        </ValidationProvider>
                                     </b-col>
                                        <b-col lg="4" sm="12">
                                        <ValidationProvider name="Promotion Title (En)" vid="promotion_title" rules="required">
                                        <b-form-group
                                         class="row"
                                         label-cols-sm="12"
                                         label-for="promotion_title"
                                         >
                                         <template v-slot:label>
                                          {{$t('promotionManagement.promotion_title_en')}} <span class="text-danger">*</span>
                                         </template>
                                         <b-form-input
                                          plain
                                          v-model="user.promotion_title"
                                          id="promotion_title"
                                          >
                                          <template v-slot:first>
                                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                          </template>
                                          </b-form-input>
                                          </b-form-group>
                                          </ValidationProvider>
                                          </b-col>
                                          <b-col lg="4" sm="12">
                                          <ValidationProvider name="Promotion Title (Bn)" vid="promotion_title_bn" rules="required">
                                          <b-form-group
                                           class="row"
                                           label-cols-sm="12"
                                           label-for="promotion_title_bn"
                                           >
                                          <template v-slot:label>
                                           {{$t('promotionManagement.promotion_title_bn')}} <span class="text-danger">*</span>
                                          </template>
                                          <b-form-input
                                             plain
                                          v-model="user.promotion_title_bn"
                                          id="promotion_title_bn"
                                          >
                                          <template v-slot:first>
                                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                          </template>
                                          </b-form-input>
                                          </b-form-group>
                                          </ValidationProvider>
                                          </b-col>
                                          <b-col lg="4" sm="12">
                                          <ValidationProvider name="Promotion Title (Bn)" vid="from_date" rules="required">
                                            <b-form-group
                                             class="row"
                                             label-cols-sm="12"
                                             label-for="from_date"
                                             >
                                             <template v-slot:label>
                                                 {{$t('promotionManagement.date_from')}} <span class="text-danger">*</span>
                                             </template>
                                             <b-form-input
                                              placeholder="Select Date"
                                              v-model="user.from_date"
                                               id="from_date"
                                               >
                                               <template v-slot:first>
                                               <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                               </template>
                                               </b-form-input>
                                               </b-form-group>
                                               </ValidationProvider>
                                        </b-col>
                                      <b-col lg="4" sm="12">
                                       <ValidationProvider name="Date To" vid="date_to" rules="required">
                                       <b-form-group
                                         class="row"
                                         label-cols-sm="12"
                                         label-for="to_date"
                                          >
                                          <template v-slot:label>
                                          {{$t('promotionManagement.date_to')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                         placeholder="Select Date"
                                         v-model="user.to_date"
                                         id="to_date"
                                         >
                                         <template v-slot:first>
                                         <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                         </template>
                                        </b-form-input>
                                         </b-form-group>
                                      </ValidationProvider>
                                     </b-col>
                                     <b-col lg="4" sm="12">
                                      <ValidationProvider name="Promotion Spot (En)" vid="promotion_spot" rules="required">
                                        <b-form-group
                                         class="row"
                                          label-cols-sm="12"
                                          label-for="promotion_spot"
                                          >
                                          <template v-slot:label>
                                          {{$t('promotionManagement.promotion_spot_en')}} <span class="text-danger">*</span>
                                          </template>
                                          <b-form-input
                                          plain
                                          v-model="user.promotion_spot"
                                          id="promotion_spot"
                                          >
                                          <template v-slot:first>
                                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                          </template>
                                          </b-form-input>
                                          </b-form-group>
                                        </ValidationProvider>
                                     </b-col>
                                     <b-col lg="4" sm="12">
                                         <ValidationProvider name="Promotion Spot (Bn)" vid="promotion_spot_bn" rules="required">
                                                            <b-form-group
                                                                class="row"
                                                                label-cols-sm="12"
                                                                label-for="promotion_spot_bn"
                                                                >
                                                                <template v-slot:label>
                                                                {{$t('promotionManagement.promotion_spot_bn')}} <span class="text-danger">*</span>
                                                                </template>
                                                                <b-form-input
                                                                plain
                                                                v-model="user.promotion_spot_bn"
                                                                id="promotion_spot_bn"
                                                                >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                                </b-form-input>
                                                            </b-form-group>
                                         </ValidationProvider>
                                     </b-col>
                                     <b-col lg="4" sm="12" v-if="add">
                                        <ValidationProvider name="attachment" vid="attachment" rules="required">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="attachment"
                                                slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{ $t('promotionManagement.attachment')}} <span v-show="!id" class="text-danger">*</span>
                                            </template>
                                            <b-form-file
                                            id="attachment"
                                            v-on:change="onFileChange"
                                            accept="image/*"
                                            v-model="user.attachment"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-file>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                        </ValidationProvider>
                                        </b-col>
                                        <b-col lg="4" sm="12" v-if="edit">
                                        <ValidationProvider name="attachment" vid="attachment">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="attachment"
                                                slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{ $t('promotionManagement.attachment')}} <span v-show="!id" class="text-danger">*</span>
                                            </template>
                                            <b-form-file
                                            id="attachment"
                                            v-on:change="onFileChange"
                                            accept="image/*"
                                            v-model="user.attachment"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-file>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                        </ValidationProvider>
                                        </b-col>
                                        <b-col lg="4" sm="12" v-if="edit">
                                             <ValidationProvider name="attachment" vid="attachment">
                                                 <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="attachment"
                                            >
                                            <template v-slot:label>
                                                {{ $t('promotionManagement.current_attachment')}}
                                            </template>
                                            <b-img width='100%' :src="productionServiceBaseUrl + 'uploads/promotion-entry/' + current_iamge" fluid alt="Attachment"></b-img>
                                             </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                </b-row>
                                <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                    &nbsp;
                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                </div>
                                </div>
                            </b-form>
                        </ValidationObserver>
                    </b-col>
                </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { promotionEntryStoreApi, promotionEntryUpdateApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
    name: 'FormLayout',
    props: ['id', 'item'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        if (this.id) {
            const tmp = this.getUserInfoData()
            this.current_iamge = tmp.attachment
            this.edit = true
            this.add = false
            // Object.freeze(tmp)
            this.user = tmp
            this.user.attachment = []
        }
    },
     mounted () {
        flatpickr('#from_date', {})
        flatpickr('#to_date', {})
        core.index()
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            user: {
                promotion_type_id: 0,
                promotion_title: '',
                promotion_spot: '',
                promotion_spot_bn: '',
                promotion_title_bn: '',
                from_date: '',
                date_to: '',
                attachment: [],
                current_iamge: ''
            },
            edit: false,
            add: true,
            upload_photo: [],
            productionServiceBaseUrl: productionServiceBaseUrl
        }
    },
    computed: {
        promotionTypesList: function () {
            const promotionTypesData = this.$store.state.ProductionService.commonObj.promotionTypeList.filter(item => item.status === 1)
            return promotionTypesData.map(item => {
                if (this.$i18n.locale === 'bn') {
                return { value: item.value, text: item.text_bn }
                } else {
                return { value: item.value, text: item.text_en }
                }
            })
        }
    },
    watch: {
    },
    methods: {
        getUserInfoData () {
          const tmpData = this.$store.state.list.find(item => item.id === this.id)
          return JSON.parse(JSON.stringify(tmpData))
        },
        onFileChange (e) {
            this.upload_photo = e.target.files[0]
        },
        async register () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadingState = { loading: false, listReload: true }

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }

            var formData = new FormData()
            Object.keys(this.user).map(key => {
                if (key === 'attachment') {
                formData.append(key, this.upload_photo)
                } else {
                formData.append(key, this.user[key])
                }
            })

            if (this.id) {
                formData.append('_method', 'PUT')
                result = await RestApi.postData(productionServiceBaseUrl, `${promotionEntryUpdateApi}/${this.id}`, formData)
            } else {
                formData.append('created_by', 1)
                result = await RestApi.postData(productionServiceBaseUrl, promotionEntryStoreApi, formData, config)
            }

            this.$store.dispatch('mutateCommonProperties', loadingState)

            if (result.success) {
                this.$store.commit('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save'),
                color: '#D6E09B'
                })

                this.$bvModal.hide('modal-4')
            } else {
                this.$refs.form.setErrors(result.errors)
            }
        }
    }
}
</script>
